import { render, staticRenderFns } from "./PaginationxCheck.vue?vue&type=template&id=35fbc441&scoped=true&"
import script from "./PaginationxCheck.vue?vue&type=script&lang=js&"
export * from "./PaginationxCheck.vue?vue&type=script&lang=js&"
import style0 from "./PaginationxCheck.vue?vue&type=style&index=0&id=35fbc441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbc441",
  null
  
)

export default component.exports